import { getFieldIcon } from 'features/admin/fields/icons/utils'
import { sortFieldsByOrder } from 'features/fields/utils'
import { filterSupportsField } from 'features/views/ListView/Filters/fields'
import { LabelledField } from 'features/views/ListView/ListHeader/Filters/Advanced/types'

import useDeepEqualsMemoValue from 'v2/ui/utils/useDeepEqualsMemoValue'

type UseAdvancedFiltersContextToolbarStateProps = {
    object?: ObjectDto
}

export function useAdvancedFiltersContextToolbarState({
    object,
}: UseAdvancedFiltersContextToolbarStateProps) {
    const availableFields = makeFields(object)
    const recommendedFieldSids = getRecommendedFieldSids(availableFields)

    return useDeepEqualsMemoValue({
        recommendedFieldSids,
        availableFields,
    })
}

function makeFields(object?: ObjectDto): LabelledField[] {
    const fields = sortFieldsByOrder(object?.fields ?? [], object)
    return fields.reduce((acc, field) => {
        if (field.connection_options?.is_disabled) return acc
        if (!filterSupportsField(field, 'advanced')) return acc

        acc.push({
            field,
            label: field.label,
            icon: getFieldIcon(field),
        })

        return acc
    }, [] as LabelledField[])
}

const RECOMMENDED_FIELD_COUNT = 4

const RECOMMENDED_FIELD_TYPES = new Set<FieldType>(['dropdown', 'multi_select', 'date', 'datetime'])

function getRecommendedFieldSids(fields: LabelledField[]): string[] {
    const recommendedFields: string[] = []

    let idx: number = 0
    for (const field of fields) {
        if (RECOMMENDED_FIELD_TYPES.has(field.field.type)) {
            recommendedFields.push(field.field._sid)
            idx++
        }

        if (idx >= RECOMMENDED_FIELD_COUNT) break
    }

    return recommendedFields
}
